export default "__VITE_PUBLIC_ASSET__bcef9944__"